import { supabase } from '@/lib/supabase';

export type ClassListItem = {
  academic_year: string;
  class_teacher_id: string | null;
  created_at: string;
  id: string;
  name: string;
  section: string | null;
};

export async function fetchClassesForSchool(schoolId: string) {
  const { data, error } = await supabase
    .from('classes')
    .select('id, name, section, academic_year, class_teacher_id, created_at')
    .eq('school_id', schoolId)
    .order('academic_year', { ascending: false })
    .order('name', { ascending: true })
    .order('section', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []) as ClassListItem[];
}

export async function createClass(input: {
  academicYear: string;
  name: string;
  schoolId: string;
  section?: string;
}) {
  const payload = {
    academic_year: input.academicYear.trim(),
    name: input.name.trim(),
    school_id: input.schoolId,
    section: input.section?.trim() || null,
  };

  const { error } = await supabase.from('classes').insert(payload);

  if (error) {
    throw error;
  }
}

export async function updateClass(input: {
  academicYear: string;
  classId: string;
  name: string;
  schoolId: string;
  section?: string;
}) {
  const payload = {
    academic_year: input.academicYear.trim(),
    name: input.name.trim(),
    section: input.section?.trim() || null,
  };

  const { error } = await supabase
    .from('classes')
    .update(payload)
    .eq('id', input.classId)
    .eq('school_id', input.schoolId);

  if (error) {
    throw error;
  }
}
